import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Alert, Typography, Button } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useSiteStore } from '../../store/site.store';
import TabbedTimelineWidget from '../../components/TabbedTimelineWidget';
import { activationService } from '../../services/activationService';

const TimelinePage: React.FC = () => {
  const navigate = useNavigate();
  const { selectedSite } = useSiteStore();

  useEffect(() => {
    if (selectedSite?.id) {
      const sessionId = sessionStorage.getItem('sessionId') || `session_${Date.now()}`;
      activationService.trackEvent(selectedSite.id, {
        eventType: 'TIMELINE_VIEWED',
        sessionId
      }).catch(err => console.error('Failed to track timeline view:', err));
    }
  }, [selectedSite?.id]);

  if (!selectedSite) {
    return (
      <Box>
        <Alert severity="info">Please select a site to view timeline</Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ 
      maxWidth: { xs: 400, sm: 768, md: 900, lg: 1200 },
      mx: 'auto',
      px: { xs: 2, sm: 3, md: 4 },
      py: 3
    }}>
      {/* Back Button */}
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate('/early-stage')}
        sx={{ mb: 2 }}
      >
        Back to Dashboard
      </Button>

      {/* Search engine timeline widget */}
      <TabbedTimelineWidget siteId={selectedSite.id} />

      {/* Expectations Section */}
      <Box mt={4}>
        <Alert severity="info">
          <Typography variant="body2" fontWeight="medium" gutterBottom>
            Understanding the Timeline
          </Typography>
          <Typography variant="body2">
            Track your SEO maturity across Google Search Console and Bing Webmaster Tools. Each tab shows search-engine-specific progress,
            from initial connection through advanced optimization readiness.
          </Typography>
        </Alert>
      </Box>
    </Box>
  );
};

export default TimelinePage;
